import { ChartProps } from '@superset-ui/core';
import {
  RaisingFallingChartFormData,
  RaisingFallingChartProps,
  TransformedDataRecord,
} from './types';

export default function transformProps(
  chartProps: ChartProps,
): RaisingFallingChartProps {
  const { width, height, formData, queriesData } = chartProps;
  const { categoryColumn = [], seriesColumns = [] } = formData;

  // Validasi data yang diperlukan
  if (!categoryColumn?.length) {
    throw new Error('Missing required Group Column configuration');
  }

  // Validasi queriesData
  if (!queriesData?.[0]?.data) {
    throw new Error('No data available');
  }

  // Transform data
  const data = queriesData[0].data.map((record: any): TransformedDataRecord => {
    const transformedRecord: TransformedDataRecord = {};

    // Ambil nilai dari group columns
    // groupColumn.forEach((col: string) => {
    //   transformedRecord[col] = record[col];
    // });
    transformedRecord[categoryColumn] = record[categoryColumn];
    // console.log(formData, record, '55555');
    transformedRecord[formData.granularitySqla] =
      record[formData.granularitySqla];
    // Ambil nilai dari metrics
    seriesColumns.forEach((column: string) => {
      transformedRecord[column] = record[column];
    });

    return transformedRecord;
  });

  return {
    width,
    height,
    formData: formData as RaisingFallingChartFormData,
    queriesData: [
      {
        ...queriesData[0],
        data,
      },
    ],
  };
}
